(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const phoneBar = event.target.closest('.header--on') && window.matchMedia('(max-width: 1023px)').matches;
      const bottom = phoneBar ? 0 : Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('on-collection-filters')) {
    customElements.define(
      'on-collection-filters',
      class OnCollectionFilters extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.toggle = this.querySelector('[data-on-toggle]');
          this.panel = this.querySelector('[data-on-panel]');
          this.form = this.querySelector('[data-on-form]');
          if (!this.toggle || !this.panel || !this.form) return;

          this.mq = window.matchMedia('(min-width: 990px)');
          this.open = false;
          this.timer = null;
          this.abort = null;

          this.onToggle = () => this.setOpen(!this.open);
          this.onClick = (event) => {
            if (event.target.closest('[data-on-close]')) {
              this.setOpen(false);
              return;
            }
            const clear = event.target.closest('[data-on-clear]');
            if (clear) {
              event.preventDefault();
              this.update(clear.getAttribute('href'));
            }
          };
          this.onChange = () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.update(this.buildUrl()), 250);
          };
          this.onSubmit = (event) => {
            event.preventDefault();
            clearTimeout(this.timer);
            this.update(this.buildUrl());
          };
          this.onKey = (event) => this.keyDown(event);
          this.onMode = () => this.syncMode();
          this.onPop = () => this.update(location.pathname + location.search, false);

          this.toggle.addEventListener('click', this.onToggle);
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKey);
          this.form.addEventListener('change', this.onChange);
          this.form.addEventListener('submit', this.onSubmit);
          this.mq.addEventListener('change', this.onMode);
          window.addEventListener('popstate', this.onPop);

          this.apply(false);

          // Floating "Show filters" pill (setting "Keep the filter button on screen while scrolling")
          this.bar = this.querySelector('.on-toolbar');
          this.shop = this.querySelector('.on-shop');
          if (this.dataset.float !== 'false' && this.bar && this.shop) {
            this.rafFloat = 0;
            this.onScroll = () => {
              if (this.rafFloat) return;
              this.rafFloat = requestAnimationFrame(() => {
                this.rafFloat = 0;
                this.syncFloat();
              });
            };
            this.onResize = () => {
              this.liftStale = true;
              this.onScroll();
            };
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onResize);
            this.syncFloat();
          }
        }

        // Float once the toolbar is above the screen, while the products still fill the screen
        // (it docks back above the grid near the end of the products, before the footer).
        syncFloat() {
          const bar = this.bar.getBoundingClientRect();
          const shop = this.shop.getBoundingClientRect();
          const float = bar.bottom < 0 && shop.bottom > window.innerHeight * 0.6;
          const was = this.toggle.classList.contains('is-floating');
          if (float && (!was || this.liftStale)) this.setLift();
          if (float !== was) this.toggle.classList.toggle('is-floating', float);
        }

        // Sit above anything fixed along the bottom of the screen (an icon bar, a cookie bar), not under it
        setLift() {
          this.liftStale = false;
          const h = window.innerHeight;
          let lift = 0;
          document.elementsFromPoint(window.innerWidth / 2, h - 2).forEach((el) => {
            if (this.toggle.contains(el)) return;
            for (let a = el; a && a !== document.body && a !== document.documentElement; a = a.parentElement) {
              const pos = getComputedStyle(a).position;
              if (pos === 'fixed' || pos === 'sticky') {
                const r = a.getBoundingClientRect();
                if (r.top > h * 0.5 && r.width > window.innerWidth * 0.5) lift = Math.max(lift, h - r.top);
                break;
              }
            }
          });
          if (lift > 0) this.toggle.style.setProperty('--on-float-lift', Math.round(lift) + 'px');
          else this.toggle.style.removeProperty('--on-float-lift');
        }

        disconnectedCallback() {
          if (!this.toggle) return;
          this.toggle.removeEventListener('click', this.onToggle);
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKey);
          this.form.removeEventListener('change', this.onChange);
          this.form.removeEventListener('submit', this.onSubmit);
          this.mq.removeEventListener('change', this.onMode);
          window.removeEventListener('popstate', this.onPop);
          if (this.onScroll) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onResize);
            cancelAnimationFrame(this.rafFloat);
          }
          document.documentElement.classList.remove('on-filters-lock');
          clearTimeout(this.timer);
          if (this.abort) this.abort.abort();
        }

        /* ---------- Open / close ---------- */
        apply(open) {
          this.open = open;
          this.setAttribute('data-state', open ? 'open' : 'closed');
          this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.panel.inert = !open;
          this.syncMode();
        }

        // Below 990px the panel is a modal bottom sheet: lock page scroll and mark it as a dialog
        syncMode() {
          const modal = this.open && !this.mq.matches;
          document.documentElement.classList.toggle('on-filters-lock', modal);
          if (modal) {
            this.panel.setAttribute('role', 'dialog');
            this.panel.setAttribute('aria-modal', 'true');
          } else {
            this.panel.removeAttribute('role');
            this.panel.removeAttribute('aria-modal');
          }
        }

        setOpen(open) {
          if (open === this.open) return;
          this.apply(open);
          requestAnimationFrame(() => {
            if (open && !this.mq.matches) {
              const close = this.panel.querySelector('.on-filters__close');
              if (close) close.focus({ preventScroll: true });
            } else if (!open) {
              this.toggle.focus({ preventScroll: true });
            }
          });
        }

        focusables() {
          return Array.from(
            this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea')
          ).filter((el) => el.getClientRects().length > 0);
        }

        keyDown(event) {
          if (!this.open) return;
          const mobile = !this.mq.matches;

          if (event.key === 'Escape' && (mobile || this.panel.contains(document.activeElement))) {
            event.preventDefault();
            this.setOpen(false);
            return;
          }

          if (event.key === 'Tab' && mobile) {
            const items = this.focusables();
            if (!items.length) return;
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }

        /* ---------- Apply filters (Search & Discovery URL parameters, no page reload) ---------- */
        buildUrl() {
          const params = new URLSearchParams();
          new FormData(this.form).forEach((value, key) => {
            if (value !== '' && value !== null) params.append(key, value);
          });
          const base = this.form.getAttribute('action') || location.pathname;
          const query = params.toString();
          return query ? base + '?' + query : base;
        }

        async update(url, push = true) {
          if (this.abort) this.abort.abort();
          this.abort = new AbortController();
          this.classList.add('is-loading');

          try {
            const separator = url.indexOf('?') > -1 ? '&' : '?';
            const response = await fetch(url + separator + 'section_id=' + encodeURIComponent(this.sectionId), {
              signal: this.abort.signal
            });
            if (!response.ok) throw new Error('Request failed: ' + response.status);

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.render(doc);
            if (push) {
              try {
                history.pushState({ onFilters: true }, '', url);
              } catch (historyError) {
                /* the results are already on screen; only the address bar could not be updated */
              }
            }
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            window.location.href = url; // always fall back to a normal page load
            return;
          }
          this.classList.remove('is-loading');
        }

        render(doc) {
          // Product grid
          const grid = this.querySelector('#ProductGridContainer');
          const nextGrid = doc.querySelector('#ProductGridContainer');
          if (grid && nextGrid) grid.innerHTML = nextGrid.innerHTML;

          // Filter options (counts, disabled values, checked state). The scroll position is kept.
          const body = this.querySelector('[data-on-body]');
          const nextBody = doc.querySelector('[data-on-body]');
          if (body && nextBody) {
            const active = document.activeElement;
            const keep =
              active && body.contains(active) && active.name
                ? { name: active.name, value: active.value }
                : null;

            body.innerHTML = nextBody.innerHTML;

            if (keep) {
              const inputs = body.querySelectorAll('input');
              for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].name === keep.name && inputs[i].value === keep.value) {
                  inputs[i].focus({ preventScroll: true });
                  break;
                }
              }
            }
          }

          // Results count (toolbar + "View results" button)
          doc.querySelectorAll('[data-on-sync]').forEach((next) => {
            const current = this.querySelector('[data-on-sync="' + next.getAttribute('data-on-sync') + '"]');
            if (current) current.innerHTML = next.innerHTML;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-activity-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-activity-links')) {
    customElements.define(
      'on-activity-links',
      class OnActivityLinks extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('[data-oal-link]'));
          this.slides = Array.from(this.querySelectorAll('[data-oal-slide]'));
          if (!this.links.length || !this.slides.length) return;

          this.current = 0;
          this.handlers = [];

          this.links.forEach((link, index) => {
            const show = () => this.show(index);
            link.addEventListener('pointerenter', show);
            link.addEventListener('focus', show);
            this.handlers.push([link, show]);
          });

          // Theme editor: selecting a block previews its image
          this.onBlockSelect = (event) => {
            const link = event.target.querySelector('[data-oal-link]');
            const index = this.links.indexOf(link);
            if (index > -1) this.show(index);
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          if (!this.handlers) return;
          this.handlers.forEach(([link, show]) => {
            link.removeEventListener('pointerenter', show);
            link.removeEventListener('focus', show);
          });
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        show(index) {
          if (index === this.current || !this.slides[index]) return;

          const previous = this.current;
          this.current = index;

          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === index);
            slide.classList.toggle('is-prev', i === previous);
          });
          this.links.forEach((link, i) => link.classList.toggle('is-active', i === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-collection-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-card-carousel')) {
    customElements.define(
      'collection-card-carousel',
      class CollectionCardCarousel extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute('data-stack')) return;

          this.track = this.querySelector('[data-ccc-track]');
          if (!this.track) return;

          this.nav = this.querySelector('[data-ccc-nav]');
          this.prev = this.querySelector('[data-ccc-prev]');
          this.next = this.querySelector('[data-ccc-next]');
          this.thumb = this.querySelector('[data-ccc-thumb]');
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;

          this.onScroll = () => this.schedule();
          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.cancelSettle();
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          const slide = track.querySelector('.ccc-slide');
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          return {
            step: slide.getBoundingClientRect().width + gap,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        go(direction) {
          const m = this.metrics();
          if (!m) return;

          this.track.scrollBy({
            left: direction * m.sign * m.step,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign; // > 0 means the scroll position is increasing
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.nav) this.nav.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);

          if (this.thumb) {
            const width = Math.min(100, Math.max(12, (track.clientWidth / track.scrollWidth) * 100));
            const offset = (position / max) * (100 - width);
            this.thumb.style.setProperty('--ccc-thumb-w', width + '%');
            this.thumb.style.setProperty('--ccc-thumb-x', offset + '%');
          }

          if (this.prev) this.prev.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-collection-header"] && !Shopify.designMode) return;
  try {
    
  /* the selected tab is scrolled into view when the row does not fit (phones) */
  if (!customElements.get('on-ch-row')) {
    customElements.define(
      'on-ch-row',
      class OnChRow extends HTMLElement {
        connectedCallback() {
          requestAnimationFrame(() => {
            const row = this.querySelector('.on-ch__scroller');
            const cur = this.querySelector('.is-current');
            if (!row || !cur || row.scrollWidth <= row.clientWidth) return;
            const r = row.getBoundingClientRect();
            const c = cur.getBoundingClientRect();
            if (c.right > r.right - 16) row.scrollLeft += c.right - r.right + 48;
            else if (c.left < r.left) row.scrollLeft -= r.left - c.left + 48;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__onContactInit) return;
    window.__onContactInit = true;

    var EMAIL = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[A-Za-z]{2,}$/;
    var RULES = {
      email: function (v) { return EMAIL.test(v); },
      letters: function (v) { return /^[\p{L}\s'.-]+$/u.test(v); },
      numbers: function (v) { return /^\d+$/.test(v); },
      phone: function (v) { return /^\+?[\d\s().-]{7,20}$/.test(v) && (v.match(/\d/g) || []).length >= 7; }
    };

    function fieldOf(el) { return el.closest('[data-onc-field]'); }
    function errorEl(field) { return field && field.querySelector('.onc__error'); }

    function check(el) {
      var v = (el.type === 'checkbox' || el.type === 'radio') ? '' : String(el.value || '').trim();
      if (el.type === 'checkbox') return el.required && !el.checked ? el.dataset.msgRequired : '';
      if (el.type === 'radio') {
        var group = el.form.querySelectorAll('input[type="radio"][name="' + CSS.escape(el.name) + '"]');
        var any = Array.prototype.some.call(group, function (r) { return r.checked; });
        return el.required && !any ? el.dataset.msgRequired : '';
      }
      if (!v) return el.required ? el.dataset.msgRequired : '';
      var min = parseInt(el.getAttribute('minlength'), 10);
      if (min > 0 && v.length < min) return el.dataset.msgShort;
      var rule = el.dataset.rule;
      if (rule === 'pattern' && el.dataset.pattern) {
        try { if (!new RegExp('^(?:' + el.dataset.pattern + ')$', 'u').test(v)) return el.dataset.msgInvalid; } catch (e) {}
      } else if (RULES[rule] && !RULES[rule](v)) {
        return el.dataset.msgInvalid;
      }
      return '';
    }

    function show(el, msg) {
      var field = fieldOf(el);
      var err = errorEl(field);
      if (!field) return;
      field.classList.toggle('is-invalid', !!msg);
      if (err) {
        err.textContent = msg || '';
        err.hidden = !msg;
      }
      if (el.type !== 'radio') el.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    function controls(form) {
      var seen = {};
      return Array.prototype.filter.call(form.querySelectorAll('[data-onc-field] input, [data-onc-field] select, [data-onc-field] textarea'), function (el) {
        if (el.type === 'radio') {
          if (seen[el.name]) return false;
          seen[el.name] = true;
        }
        return true;
      });
    }

    function init(form) {
      if (form.__onc) return;
      form.__onc = true;
      form.noValidate = true; // our messages instead of the browser's bubbles

      // on.ae checks everything on submit; this runs before Shopify's spam check (which listens on the document)
      form.addEventListener('submit', function (e) {
        var first = null;
        controls(form).forEach(function (el) {
          var msg = check(el);
          show(el, msg);
          if (msg && !first) first = el;
        });
        if (first) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var f = fieldOf(first);
          if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
          first.focus({ preventScroll: true });
          return;
        }
        var btn = form.querySelector('[data-onc-submit]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      });

      // a fixed field loses its error at once
      form.addEventListener('input', function (e) {
        var el = e.target;
        var field = fieldOf(el);
        if (field && field.classList.contains('is-invalid') && !check(el)) show(el, '');
        var counter = field && field.querySelector('[data-onc-counter]');
        if (counter) counter.textContent = el.value.length + ' / ' + counter.dataset.oncCounter;
      });
      form.addEventListener('change', function (e) {
        var el = e.target;
        var field = fieldOf(el);
        if (field && field.classList.contains('is-invalid') && !check(el)) show(el, '');
      });
      // back button after sending: the button is usable again
      window.addEventListener('pageshow', function () {
        var btn = form.querySelector('[data-onc-submit]');
        if (btn) btn.removeAttribute('aria-busy');
      });
    }

    function run() {
      document.querySelectorAll('.onc__form').forEach(init);
      // after sending: bring the thank-you into view
      var done = document.querySelector('[data-onc-done]');
      if (done && /contact_posted=true/.test(location.search)) {
        var sec = done.closest('.onc') || done;
        requestAnimationFrame(function () {
          sec.scrollIntoView({ block: 'start' });
          done.focus({ preventScroll: true });
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-editorial-carousel')) {
    customElements.define(
      'on-editorial-carousel',
      class OnEditorialCarousel extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('[data-oec-stage]');
          this.intro = this.querySelector('[data-oec-intro]');
          this.cards = this.querySelector('[data-oec-cards]');
          this.track = this.querySelector('[data-oec-track]');
          if (!this.stage || !this.track) return;

          this.openBtn = this.querySelector('[data-oec-open]');
          this.closeBtn = this.querySelector('[data-oec-close]');
          this.arrows = this.querySelector('[data-oec-arrows]');
          this.prev = this.querySelector('[data-oec-prev]');
          this.next = this.querySelector('[data-oec-next]');

          this.expanded = false;
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;
          this.heightTimer = null;

          this.onOpen = () => this.setExpanded(true);
          this.onClose = () => this.setExpanded(false);
          this.onEscape = (e) => {
            if (e.key === 'Escape' && this.expanded) this.setExpanded(false);
          };
          this.onScroll = () => this.schedule();
          this.onPrev = () => {
            if (this.prev.getAttribute('aria-disabled') !== 'true') this.page(-1);
          };
          this.onNext = () => {
            if (this.next.getAttribute('aria-disabled') !== 'true') this.page(1);
          };
          this.onKeyDown = (e) => this.keyDown(e);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          if (this.openBtn) this.openBtn.addEventListener('click', this.onOpen);
          if (this.closeBtn) this.closeBtn.addEventListener('click', this.onClose);
          this.addEventListener('keydown', this.onEscape);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(() => this.schedule());
          this.resizeObserver.observe(this.track);

          this.apply(false);
        }

        disconnectedCallback() {
          if (!this.track) return;
          if (this.openBtn) this.openBtn.removeEventListener('click', this.onOpen);
          if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onClose);
          this.removeEventListener('keydown', this.onEscape);
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          clearTimeout(this.heightTimer);
          this.cancelSettle();
        }

        /* ---------- Open / close ---------- */
        apply(expanded) {
          this.expanded = expanded;
          this.setAttribute('data-state', expanded ? 'expanded' : 'collapsed');
          if (this.intro) this.intro.inert = expanded;
          if (this.cards) this.cards.inert = !expanded;
          if (this.openBtn) this.openBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        setExpanded(expand) {
          if (this.expanded === expand) return;

          const stage = this.stage;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          clearTimeout(this.heightTimer);
          stage.style.height = '';
          if (!expand) this.track.scrollTo({ left: 0, behavior: 'auto' });

          if (reduce) {
            this.apply(expand);
          } else {
            // Measure both layouts, then animate the section height between them.
            const first = stage.getBoundingClientRect().height;
            this.setAttribute('data-measuring', '');
            this.apply(expand);
            const last = stage.getBoundingClientRect().height;
            this.apply(!expand);
            stage.style.height = first + 'px';
            void stage.offsetHeight;
            this.removeAttribute('data-measuring');

            this.apply(expand);
            stage.style.height = last + 'px';
            this.heightTimer = setTimeout(() => {
              stage.style.height = '';
            }, 900);
          }

          this.schedule();
          requestAnimationFrame(() => {
            const target = expand ? this.closeBtn : this.openBtn;
            if (target) target.focus({ preventScroll: true });
          });
        }

        /* ---------- Slider ---------- */
        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          const slide = track.querySelector('.oec-slide');
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          const step = slide.getBoundingClientRect().width + gap;
          if (!step) return null;
          return {
            step,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            visible: Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.05)),
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        page(direction) {
          const m = this.metrics();
          if (!m) return;
          this.track.scrollBy({
            left: direction * m.sign * m.step * m.visible,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        keyDown(e) {
          if (!this.expanded) return;
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          const m = this.metrics();
          if (!m) return;

          const behavior = m.reduce ? 'auto' : 'smooth';
          if (e.key === 'ArrowRight') {
            this.track.scrollBy({ left: m.step, behavior });
          } else if (e.key === 'ArrowLeft') {
            this.track.scrollBy({ left: -m.step, behavior });
          } else if (e.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior });
          } else if (e.key === 'End') {
            this.track.scrollTo({ left: m.sign * m.max, behavior });
          } else {
            return;
          }
          e.preventDefault();
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (!this.expanded) return;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign;
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        /* ---------- Arrow state ---------- */
        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.arrows) this.arrows.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);
          if (this.prev) this.prev.setAttribute('aria-disabled', position <= 2 ? 'true' : 'false');
          if (this.next) this.next.setAttribute('aria-disabled', position >= max - 2 ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('on-faq')) return;

    var STOP = ['a','an','the','my','i','to','of','is','are','for','and','or','how','do','does','can','what','in','on','it','me','your','you','with','be','if','at','we','when','where','why','will','this','that','from','by','as','am','was','get'];
    var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var reEsc = function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var textOf = function (el) {
      var c = el.cloneNode(true);
      c.querySelectorAll('p, li, br, h1, h2, h3, h4, h5, h6, div, tr, td, th').forEach(function (n) { n.after(' '); });
      return c.textContent.replace(/\s+/g, ' ').trim();
    };
    var norm = function (t) { return String(t || '').toLowerCase().replace(/[^\p{L}\p{N}\s'-]+/gu, ' ').replace(/\s+/g, ' ').trim(); };

    class OnFaq extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.sid = this.dataset.section;
        this.mq = window.matchMedia('(min-width: 1024px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.wrap = this.querySelector('.onfaq__panels');
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.onfaq__panel'));
        this.links = Array.prototype.slice.call(this.querySelectorAll('[data-topic-link]'));
        this.list = this.querySelector('.onfaq__m-list');
        this.pill = this.querySelector('.onfaq__pill');
        this.pillT = this.querySelector('.onfaq__pill-t');
        this.current = null;
        if (this.dataset.underlineActive === 'true') this.classList.add('onfaq--underline-active');

        var self = this;
        this.links.forEach(function (a) {
          a.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
            if (!self.panel(a.dataset.topicLink)) return;
            e.preventDefault();
            self.open(a.dataset.topicLink, { push: true, user: true, kbd: e.detail === 0 });
          });
        });

        this.panels.forEach(function (p) { self.bindDetails(p); });

        /* tab title: "<page title><theme suffix>", e.g. "Returns – On Running Pakistan" */
        var curT = this.dataset.curTitle || '', docT = document.title;
        this.titleSuffix = curT && docT.indexOf(curT) === 0 ? docT.slice(curT.length) : '';

        if (this.pill) this.pill.addEventListener('click', function () {
          self.setList(self.pill.getAttribute('aria-expanded') !== 'true', true);
        });

        this.setupSearch();

        this._pop = function () { self.fromUrl(false); };
        window.addEventListener('popstate', this._pop);

        this._sel = function (e) {
          if (!e.detail || e.detail.sectionId !== self.sid) return;
          self.panels.forEach(function (x) { self.hydrate(x); });
          var el = self.querySelector('[data-block="' + e.detail.blockId + '"]');
          if (!el) return;
          if (el.classList.contains('onfaq__panel')) self.open(el.dataset.topic, { push: false, user: true });
          else {
            var p = el.closest('.onfaq__panel');
            if (p) self.open(p.dataset.topic, { push: false, user: true, q: el });
          }
        };
        document.addEventListener('shopify:block:select', this._sel);

        this.fromUrl(true);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this._pop);
        document.removeEventListener('shopify:block:select', this._sel);
        this._ready = false;
      }

      bindDetails(root) {
        var self = this;
        root.querySelectorAll('details.onfaq__q').forEach(function (d) {
          if (d._bound) return;
          d._bound = true;
          d.querySelector('summary').addEventListener('click', function (e) {
            e.preventDefault();
            self.setQ(d, !d.classList.contains('is-open'), true);
          });
          d.addEventListener('toggle', function () { if (!d._anim) d.classList.toggle('is-open', d.open); });
        });
      }

      /* topics stored in a <template> (on another topic's page) are put in place the first time they are needed */
      hydrate(p) {
        if (!p || !p.hasAttribute('data-lazy')) return;
        var t = p.querySelector('template');
        p.removeAttribute('data-lazy');
        if (!t) return;
        p.appendChild(document.importNode(t.content, true));
        t.remove();
        this.bindDetails(p);
      }

      setTitle(t) {
        if (t) document.title = t + this.titleSuffix;
      }

      cleanPath(u) {
        try { return decodeURI(u).replace(/\/+$/, '').toLowerCase(); } catch (e) { return String(u).toLowerCase(); }
      }

      panel(topic) {
        for (var i = 0; i < this.panels.length; i++) if (this.panels[i].dataset.topic === topic) return this.panels[i];
        return null;
      }

      fromUrl(initial) {
        var self = this;
        var params = new URLSearchParams(window.location.search);
        var topic = params.get('topic');
        var p = topic && this.panel(topic);
        if (!p) {
          var here = this.cleanPath(window.location.pathname);
          this.panels.forEach(function (x) { if (!p && x.dataset.path && self.cleanPath(x.dataset.path) === here) p = x; });
        }
        if (p) {
          var q = null;
          this.hydrate(p);
          if (window.location.hash) {
            try { q = p.querySelector(decodeURIComponent(window.location.hash)); } catch (err) { q = null; }
          }
          if (initial && !p.hidden) {
            /* already open from the server (the topic's own page) */
            this.current = p;
            if (q) { this.setQ(q, true, false); this.scrollTo(q, 16); }
          } else {
            this.open(p.dataset.topic, { push: false, user: !initial, q: q, noTitle: initial });
          }
        } else if (initial && this.dataset.firstTopic === 'true' && this.mq.matches && this.panels.length) {
          this.open(this.panels[0].dataset.topic, { push: false, noTitle: true });
        } else if (!initial) {
          this.close();
        }
      }

      open(topic, o) {
        o = o || {};
        var p = this.panel(topic);
        if (!p) return;
        var self = this, prev = this.current;
        this.hydrate(p);

        this.links.forEach(function (a) {
          if (a.dataset.topicLink === topic) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
        this.classList.add('has-topic');
        if (this.pillT) this.pillT.textContent = p.dataset.title;
        if (!this.mq.matches) this.setList(false, !!o.user);

        if (o.push && this.dataset.url === 'true' && p.dataset.url) {
          /* like on.ae: the address becomes the topic's page (/pages/returns), without reloading */
          var u = new URL(p.dataset.url, window.location.href);
          if (u.href !== window.location.href) history.pushState({ onFaq: topic }, '', u.href);
        }
        if (!o.noTitle) this.setTitle(p.dataset.docTitle || this.dataset.baseTitle);

        var show = function () {
          self.panels.forEach(function (x) { x.hidden = x !== p; });
          self.current = p;
          var open = p.querySelector('details.onfaq__q.is-open');
          if (!o.q && !open && self.dataset.firstQuestion === 'true') {
            var first = p.querySelector('details.onfaq__q');
            if (first) self.setQ(first, true, false);
          }
          if (o.q) self.setQ(o.q, true, false);
        };
        var after = function () {
          var phone = !self.mq.matches && self.list;
          if (o.q) {
            /* on phones wait until the topic list has folded away, then the question is where it stays */
            if (phone && self.list._anim) setTimeout(function () { self.scrollTo(o.q, 16); }, 320);
            else self.scrollTo(o.q, 16);
          } else if (o.user && self.dataset.scroll === 'true') {
            /* phones: the list folds up above the yellow button, so its top is where the button ends up */
            self.scrollTo(phone ? self.list : p, 16, true);
          }
          if (o.kbd) {
            var t = p.querySelector('.onfaq__ptitle');
            if (t) t.focus({ preventScroll: true });
          }
        };

        clearTimeout(this._ft);
        if (prev && prev !== p && !this.reduce) {
          this.wrap.classList.add('is-out');
          this._ft = setTimeout(function () {
            show();
            void self.wrap.offsetHeight;
            self.wrap.classList.remove('is-out');
            after();
          }, 300);
        } else {
          if (prev !== p) this.wrap.classList.add('is-out');
          show();
          if (this.reduce) this.wrap.classList.remove('is-out');
          else requestAnimationFrame(function () { requestAnimationFrame(function () { self.wrap.classList.remove('is-out'); }); });
          after();
        }
      }

      close() {
        clearTimeout(this._ft);
        this.panels.forEach(function (x) { x.hidden = true; });
        this.links.forEach(function (a) { a.removeAttribute('aria-current'); });
        this.current = null;
        this.classList.remove('has-topic');
        this.wrap.classList.add('is-out');
        if (this.pillT) this.pillT.textContent = this.dataset.pill || '';
        this.setList(true, false);
        this.setTitle(this.dataset.baseTitle);
      }

      setList(open, animate) {
        if (!this.list || !this.pill) return;
        var l = this.list, was = this.pill.getAttribute('aria-expanded') === 'true';
        this.pill.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (was === open) return;
        if (l._anim) l._anim.cancel();
        if (!animate || this.reduce || !l.animate) { l.classList.toggle('is-closed', !open); return; }
        if (open) {
          l.classList.remove('is-closed');
          var h = l.scrollHeight;
          l._anim = l.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 300, easing: 'ease-in-out' });
          l._anim.onfinish = function () { l._anim = null; };
        } else {
          var h2 = l.offsetHeight;
          l._anim = l.animate([{ height: h2 + 'px' }, { height: '0px' }], { duration: 300, easing: 'ease-in-out' });
          l._anim.onfinish = function () { l.classList.add('is-closed'); l._anim = null; };
        }
      }

      setQ(d, open, animate) {
        var body = d.querySelector('.onfaq__a');
        var self = this;
        if (d._anim) { var a = d._anim; d._anim = null; a.cancel(); }
        d.classList.remove('is-anim');
        d.classList.toggle('is-open', open);
        if (open) {
          if (this.dataset.oneOpen === 'true') {
            var p = d.closest('.onfaq__panel');
            if (p) p.querySelectorAll('details.onfaq__q.is-open').forEach(function (x) { if (x !== d) self.setQ(x, false, animate); });
          }
          d.open = true;
          if (animate && !this.reduce && body.animate) {
            d.classList.add('is-anim');
            var h = body.scrollHeight;
            var ao = body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 250, easing: 'ease-in-out' });
            d._anim = ao;
            ao.onfinish = function () { if (d._anim === ao) { d._anim = null; d.classList.remove('is-anim'); } };
          }
        } else if (animate && !this.reduce && body.animate && d.open) {
          d.classList.add('is-anim');
          var h0 = body.offsetHeight;
          var an = body.animate([{ height: h0 + 'px' }, { height: '0px' }], { duration: 250, easing: 'ease-in-out' });
          d._anim = an;
          an.onfinish = function () { if (d._anim === an) { d._anim = null; d.open = false; d.classList.remove('is-anim'); } };
        } else {
          d.open = false;
        }
      }

      headerOffset() {
        var sh = document.querySelector('sticky-header');
        if (!sh || sh.dataset.stickyType === 'none') return 0;
        var w = sh.closest('.section-header') || sh;
        return w.offsetHeight || 0;
      }

      scrollTo(el, gap, onlyIfNeeded) {
        var self = this;
        requestAnimationFrame(function () {
          var off = self.headerOffset() + (gap || 0);
          var r = el.getBoundingClientRect();
          if (onlyIfNeeded && r.top >= off && r.top < window.innerHeight - 120) return;
          window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - off), behavior: self.reduce ? 'auto' : 'smooth' });
        });
      }

      /* ---------- search */
      setupSearch() {
        var self = this;
        this.input = this.querySelector('.onfaq__input');
        if (!this.input) return;
        this.clearBtn = this.querySelector('.onfaq__clear');
        this.sugg = this.querySelector('.onfaq__sugg');
        this.results = this.querySelector('.onfaq__results');
        this.resList = this.querySelector('.onfaq__res-list');
        this.resN = this.querySelector('.onfaq__res-n');
        this.resNone = this.querySelector('.onfaq__res-none');
        var tpl = this.querySelector('.onfaq__res-tpl');
        this.moreText = tpl ? tpl.dataset.more : '';

        var t;
        this.input.addEventListener('input', function () {
          clearTimeout(t);
          self.clearBtn.hidden = !self.input.value;
          t = setTimeout(function () { self.search(self.input.value); }, 200);
        });
        this.input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.input.value) { e.preventDefault(); self.clearSearch(); }
          if (e.key === 'Enter') { e.preventDefault(); clearTimeout(t); self.search(self.input.value); }
        });
        this.clearBtn.addEventListener('click', function () { self.clearSearch(); self.input.focus(); });
        this.querySelectorAll('.onfaq__chip').forEach(function (c) {
          c.addEventListener('click', function () {
            self.input.value = c.textContent.trim();
            self.clearBtn.hidden = false;
            self.search(self.input.value);
          });
        });
        this.resList.addEventListener('click', function (e) {
          var a = e.target.closest('.onfaq__res');
          if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
          var it = self.index[+a.dataset.i];
          if (!it) return;
          e.preventDefault();
          self.open(it.topic, { push: true, user: true, q: it.d, kbd: e.detail === 0 });
        });
      }

      buildIndex() {
        var self = this, out = [];
        this.panels.forEach(function (p) { self.hydrate(p); });
        this.panels.forEach(function (p) {
          p.querySelectorAll('details.onfaq__q').forEach(function (d) {
            var q = d.querySelector('.onfaq__qtext').textContent.replace(/\s+/g, ' ').trim();
            var a = textOf(d.querySelector('.onfaq__a-in'));
            out.push({ d: d, topic: p.dataset.topic, url: p.dataset.url || '', title: p.dataset.title, q: q, a: a, qn: norm(q), an: norm(a) });
          });
        });
        return out;
      }

      clearSearch() {
        this.input.value = '';
        this.clearBtn.hidden = true;
        this.search('');
      }

      search(raw) {
        if (!this.index) this.index = this.buildIndex();
        var query = norm(raw);
        var words = query.split(' ').filter(function (w) { return w.length > 1; });
        var main = words.filter(function (w) { return STOP.indexOf(w) === -1; });
        if (!main.length) main = words;
        if (!query || !main.length) {
          this.results.hidden = true;
          if (this.sugg) this.sugg.hidden = false;
          return;
        }
        var hits = [];
        this.index.forEach(function (it, i) {
          var sc = 0;
          main.forEach(function (w) {
            if (it.qn.indexOf(w) > -1) sc += 3;
            if (it.an.indexOf(w) > -1) sc += 1;
          });
          if (sc && main.length > 1 && it.qn.indexOf(query) > -1) sc += 6;
          if (sc) hits.push({ i: i, sc: sc });
        });
        hits.sort(function (x, y) { return y.sc - x.sc || x.i - y.i; });

        var re = new RegExp('(' + main.map(reEsc).sort(function (x, y) { return y.length - x.length; }).join('|') + ')', 'gi');
        var mark = function (t) {
          return esc(t).replace(re, function (m) { return '<mark>' + m + '</mark>'; });
        };
        var self = this, html = '';
        hits.forEach(function (h) {
          var it = self.index[h.i];
          html += '<a class="onfaq__res" href="' + esc((it.url || '?topic=' + encodeURIComponent(it.topic)) + '#' + it.d.id) + '" data-i="' + h.i + '">' +
            '<span class="onfaq__res-t">' + esc(it.title) + '</span>' +
            '<p class="onfaq__res-q">' + mark(it.q) + '</p>' +
            '<div class="onfaq__res-a">' + mark(it.a) + '</div>' +
            (self.moreText ? '<span class="onfaq__res-more">' + esc(self.moreText) + '</span>' : '') +
            '</a>';
        });
        this.resList.innerHTML = html;
        this.resN.textContent = hits.length;
        this.resNone.hidden = hits.length > 0;
        this.resNone.textContent = hits.length ? '' : (this.resNone.dataset.text || '').replace('[query]', raw.trim());
        this.results.hidden = false;
        if (this.sugg) this.sugg.hidden = true;
      }
    }

    customElements.define('on-faq', OnFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Colour viewer (like on.ae): a click on a swatch opens the colour full screen ----------
     One full-size photo per colour of THAT product (the swatches of the card), in swatch order.
     Arrows (bottom left), swipe, keyboard (left / right, Esc), x (top right). The card follows the colour shown,
     so after closing it shows the colour the shopper stopped on. Used when the slider has data-ofc-viewer. */
  if (!window.OfcViewer) {
    window.OfcViewer = (function () {
      let root, img, label, slides = [], index = 0, onPick = null, lastFocus = null, startX = null, token = 0;

      const icon = (d) => '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';

      function build() {
        root = document.createElement('div');
        root.className = 'ofc-lb';
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-label', 'Colours');
        root.hidden = true;
        root.innerHTML =
          '<div class="ofc-lb__stage"><img class="ofc-lb__img" alt="" draggable="false"></div>' +
          '<p class="ofc-lb__label" aria-live="polite"></p>' +
          '<button type="button" class="ofc-lb__btn ofc-lb__close" aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false"><path d="m5.64 5.64 12.72 12.72M5.64 18.36 18.36 5.64"/></svg></button>' +
          '<div class="ofc-lb__nav">' +
          '<button type="button" class="ofc-lb__btn ofc-lb__prev" aria-label="Previous colour">' + icon('m4.707 12.5 4.147 4.146-.707.708L2.793 12l5.354-5.354.707.708L4.707 11.5H21v1H4.707Z') + '</button>' +
          '<button type="button" class="ofc-lb__btn ofc-lb__next" aria-label="Next colour">' + icon('m19.293 11.5-4.147-4.146.708-.708L21.207 12l-5.353 5.354-.708-.707 4.147-4.147H3v-1h16.293Z') + '</button>' +
          '</div>';
        document.body.appendChild(root);
        img = root.querySelector('.ofc-lb__img');
        label = root.querySelector('.ofc-lb__label');
        root.querySelector('.ofc-lb__close').addEventListener('click', close);
        root.querySelector('.ofc-lb__prev').addEventListener('click', () => go(index - 1));
        root.querySelector('.ofc-lb__next').addEventListener('click', () => go(index + 1));
        root.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); close(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - (document.dir === 'rtl' ? -1 : 1)); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + (document.dir === 'rtl' ? -1 : 1)); }
          else if (e.key === 'Tab') {
            // keep the focus inside the viewer
            const f = Array.prototype.filter.call(root.querySelectorAll('button'), (b) => !b.disabled && b.offsetParent !== null);
            if (!f.length) return;
            const i = f.indexOf(document.activeElement);
            if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
            else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
          }
        });
        // swipe (touch and pen; a mouse uses the arrows)
        root.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') startX = e.clientX; });
        root.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1) * (document.dir === 'rtl' ? -1 : 1));
        });
        root.addEventListener('pointercancel', () => { startX = null; });
      }

      function show() {
        const s = slides[index];
        const my = ++token;
        img.style.opacity = '0';
        const loader = new Image();
        if (s.srcset) { loader.srcset = s.srcset; loader.sizes = '100vw'; }
        loader.src = s.src;
        const put = () => {
          if (my !== token) return;
          if (s.srcset) { img.srcset = s.srcset; img.sizes = '100vw'; } else { img.removeAttribute('srcset'); }
          img.src = s.src;
          img.alt = s.name;
          img.style.opacity = '';
        };
        if (loader.decode) loader.decode().then(put, put); else { loader.onload = put; loader.onerror = put; }
        label.textContent = s.name + ' (' + (index + 1) + ' / ' + slides.length + ')';
        const one = slides.length < 2;
        root.querySelector('.ofc-lb__nav').hidden = one;
        // warm the next one
        const n = slides[(index + 1) % slides.length];
        if (n && !one) { const w = new Image(); if (n.srcset) { w.srcset = n.srcset; w.sizes = '100vw'; } w.src = n.src; }
      }

      function go(i) {
        if (!slides.length) return;
        index = (i + slides.length) % slides.length;
        show();
        if (onPick && slides[index].btn) onPick(slides[index].btn);
      }

      function open(card, btn, pick) {
        if (!card || !btn) return;
        const btns = Array.prototype.slice.call(card.querySelectorAll('.ofc-swatch'));
        slides = btns.filter((b) => b.dataset.full || b.dataset.image).map((b) => ({
          btn: b,
          src: b.dataset.full || b.dataset.image,
          srcset: b.dataset.fullSrcset || b.dataset.srcset || '',
          name: b.getAttribute('aria-label') || ''
        }));
        index = slides.findIndex((s) => s.btn === btn);
        if (index < 0) return;   // a colour without a photo: nothing to show
        if (!root) build();
        onPick = pick || null;
        lastFocus = btn;
        // same grey as the card images (setting "Image background"), so photos with a grey background blend in
        const bg = getComputedStyle(card).getPropertyValue('--ofc-media-bg').trim();
        root.style.background = bg || '';
        root.hidden = false;
        document.documentElement.classList.add('ofc-lb-open');
        requestAnimationFrame(() => root.classList.add('is-open'));
        show();
        root.querySelector('.ofc-lb__close').focus({ preventScroll: true });
      }

      function close() {
        if (!root || root.hidden) return;
        token++;
        root.classList.remove('is-open');
        root.hidden = true;
        document.documentElement.classList.remove('ofc-lb-open');
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      }

      return { open: open, close: close };
    })();
  }

  if (!customElements.get('on-featured-collection')) {
    customElements.define(
      'on-featured-collection',
      class OnFeaturedCollection extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ofc-track]');
          if (!this.track) return;

          this.nav = this.querySelector('[data-ofc-nav]');
          this.prev = this.querySelector('[data-ofc-prev]');
          this.next = this.querySelector('[data-ofc-next]');
          this.thumb = this.querySelector('[data-ofc-thumb]');
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;

          this.onScroll = () => this.schedule();
          this.onPrev = () => {
            if (this.prev.getAttribute('aria-disabled') !== 'true') this.page(-1);
          };
          this.onNext = () => {
            if (this.next.getAttribute('aria-disabled') !== 'true') this.page(1);
          };
          this.onKeyDown = (e) => this.keyDown(e);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          this.onSwatchClick = (e) => {
            const btn = e.target.closest ? e.target.closest('.ofc-swatch') : null;
            if (!btn || !this.contains(btn)) return;
            this.selectSwatch(btn);
            if (this.hasAttribute('data-ofc-viewer') && window.OfcViewer) {
              const card = btn.closest('[data-ofc-card]');
              window.OfcViewer.open(card, btn, (b) => this.selectSwatch(b));
            }
          };
          this.track.addEventListener('click', this.onSwatchClick);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          this.track.removeEventListener('click', this.onSwatchClick);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.cancelSettle();
        }

        /* ---------- Colour swatches (same behaviour as the collection grid cards) ---------- */
        selectSwatch(btn) {
          if (btn.classList.contains('is-active')) return;
          const card = btn.closest('[data-ofc-card]');
          if (!card) return;

          card.querySelectorAll('.ofc-swatch').forEach((swatch) => {
            const on = swatch === btn;
            swatch.classList.toggle('is-active', on);
            swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          card.classList.add('is-swatched');

          // The card links now open the chosen colour
          if (btn.dataset.url) {
            card.querySelectorAll('[data-ofc-link]').forEach((link) => link.setAttribute('href', btn.dataset.url));
          }

          // The badge of the chosen colour (empty = this colour has none)
          const badge = card.querySelector('[data-ofc-badge]');
          if (badge && btn.hasAttribute('data-badge')) {
            const text = btn.getAttribute('data-badge') || '';
            badge.textContent = text;
            badge.hidden = !text;
          }

          // The main image: preload, then fade
          const img = card.querySelector('.ofc-img--main');
          const src = btn.dataset.image;
          if (!img || !src) return;
          const srcset = btn.dataset.srcset;
          const token = String(Date.now()) + Math.random();
          card.dataset.swapToken = token;
          const loader = new Image();
          if (srcset) loader.srcset = srcset;
          if (img.sizes) loader.sizes = img.sizes;
          loader.src = src;
          const swap = () => {
            if (card.dataset.swapToken !== token) return;
            img.style.transition = 'opacity 0.16s ease';
            img.style.opacity = '0';
            setTimeout(() => {
              if (card.dataset.swapToken !== token) return;
              if (srcset) img.srcset = srcset;
              img.src = src;
              img.style.opacity = '';
              setTimeout(() => { if (card.dataset.swapToken === token) img.style.transition = ''; }, 200);
            }, 160);
          };
          if (loader.decode) loader.decode().then(swap, swap);
          else if (loader.complete) swap();
          else { loader.onload = swap; loader.onerror = swap; }
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          // the first VISIBLE card (the related products section keeps a Men and a Women card per product, one is hidden)
          let slide = null;
          for (const el of track.querySelectorAll('.ofc-slide')) {
            if (el.getClientRects().length) { slide = el; break; }
          }
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          const step = slide.getBoundingClientRect().width + gap;
          return {
            step,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            visible: Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.05)),
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        /* Prev / next buttons: move one "page" of fully visible cards */
        page(direction) {
          const m = this.metrics();
          if (!m) return;
          this.track.scrollBy({
            left: direction * m.sign * m.step * m.visible,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        /* Keyboard: left/right arrows move one card, Home/End jump to the ends */
        keyDown(e) {
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          const m = this.metrics();
          if (!m) return;

          const behavior = m.reduce ? 'auto' : 'smooth';
          if (e.key === 'ArrowRight') {
            this.track.scrollBy({ left: m.step, behavior });
          } else if (e.key === 'ArrowLeft') {
            this.track.scrollBy({ left: -m.step, behavior });
          } else if (e.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior });
          } else if (e.key === 'End') {
            this.track.scrollTo({ left: m.sign * m.max, behavior });
          } else {
            return;
          }
          e.preventDefault();
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign; // > 0 means the scroll position is increasing
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        /* ---------- UI state ---------- */
        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.nav) this.nav.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);

          if (this.thumb) {
            const width = Math.min(100, Math.max(12, (track.clientWidth / track.scrollWidth) * 100));
            const offset = (position / max) * (100 - width);
            this.thumb.style.setProperty('--ofc-thumb-w', width + '%');
            this.thumb.style.setProperty('--ofc-thumb-x', offset + '%');
          }

          // Dim (or hide, see data-end) the arrows at the start / end of the track
          if (this.prev) this.prev.setAttribute('aria-disabled', position <= 2 ? 'true' : 'false');
          if (this.next) this.next.setAttribute('aria-disabled', position >= max - 2 ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-footer-newsletter')) {
    customElements.define(
      'on-footer-newsletter',
      class OnFooterNewsletter extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('.on-ft__input');
          this.status = this.querySelector('.on-ft__status');
          if (!this.form || !this.input) return;

          this.setAttribute('data-js', '');
          // the page was reloaded after a normal (non-AJAX) signup: Shopify rendered the success message inside the form
          if (this.querySelector('[data-on-ft-success]')) this.setAttribute('data-state', 'success');
          this.onFocus = () => this.setAttribute('data-open', '');
          this.onInput = () => {
            this.clearMessage();
            this.sync();
          };
          this.onBlur = () => this.sync();
          this.onSubmit = (event) => this.submit(event);

          this.input.addEventListener('focus', this.onFocus);
          this.input.addEventListener('input', this.onInput);
          this.input.addEventListener('blur', this.onBlur);
          this.form.addEventListener('submit', this.onSubmit);
          this.sync();
        }

        disconnectedCallback() {
          if (!this.input) return;
          this.input.removeEventListener('focus', this.onFocus);
          this.input.removeEventListener('input', this.onInput);
          this.input.removeEventListener('blur', this.onBlur);
          this.form.removeEventListener('submit', this.onSubmit);
        }

        // keep the consent text and button open while there is something to subscribe
        sync() {
          const keep = this.input.value.trim() !== '' || this.contains(document.activeElement);
          this.toggleAttribute('data-open', keep);
        }

        message(text, kind) {
          this.status.replaceChildren();
          if (!text) return;
          const p = document.createElement('p');
          p.className = 'on-ft__msg on-ft__msg--' + kind;
          if (kind === 'success') p.setAttribute('data-on-ft-success', '');
          else p.setAttribute('data-on-ft-error', '');
          p.textContent = text;
          this.status.appendChild(p);
        }

        clearMessage() {
          this.input.removeAttribute('aria-invalid');
          this.status.replaceChildren();
        }

        invalid(text) {
          this.input.setAttribute('aria-invalid', 'true');
          this.message(text, 'error');
          this.input.focus();
        }

        // Shopify answers the POST with a redirect to the same page; we read the result from that page
        async submit(event) {
          if (this.form.dataset.native === '1') return;
          event.preventDefault();
          if (this.hasAttribute('data-busy')) return;

          const email = this.input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            this.invalid(this.dataset.invalid || 'Email is invalid');
            return;
          }

          this.setAttribute('data-busy', '');
          try {
            const response = await fetch(this.form.getAttribute('action'), {
              method: 'POST',
              body: new FormData(this.form),
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok || response.url.indexOf('/challenge') > -1) throw new Error('native');

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const posted = doc.getElementById(this.form.id);
            if (posted && posted.querySelector('[data-on-ft-success]')) {
              this.message(this.dataset.success || 'Thanks for subscribing', 'success');
              this.setAttribute('data-state', 'success');
              this.removeAttribute('data-open');
              document.dispatchEvent(new CustomEvent('on:newsletter-subscribed', { detail: { email: email } }));
            } else if (posted && posted.querySelector('[data-on-ft-error]')) {
              this.invalid(posted.querySelector('[data-on-ft-error]').textContent.trim() || this.dataset.error);
            } else {
              throw new Error('native');
            }
          } catch (error) {
            // spam check, network hiccup, unknown answer: let the browser do a normal submit instead
            this.form.dataset.native = '1';
            this.form.submit();
            return;
          }
          this.removeAttribute('data-busy');
        }
      }
    );
  }

  if (!customElements.get('on-footer-region')) {
    customElements.define(
      'on-footer-region',
      class OnFooterRegion extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-on-ft-dialog]');
          this.opener = this.querySelector('[data-on-ft-region-open]');
          if (!this.dialog || !this.opener || typeof this.dialog.showModal !== 'function') return;

          this.onOpen = () => this.dialog.showModal();
          this.onClick = (event) => {
            if (event.target.closest('[data-on-ft-region-close]') || event.target === this.dialog) this.dialog.close();
          };
          this.opener.addEventListener('click', this.onOpen);
          this.dialog.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          if (!this.opener) return;
          this.opener.removeEventListener('click', this.onOpen);
          this.dialog.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  /* ---------- Shopify Inbox: a contact link set to "Open the live chat" opens the chat panel ----------
     Shopify Inbox (2025+) adds <shopify-chat> to the page; it has show() / close(). Older Inbox used
     <inbox-online-store-chat> with a button inside. If neither is there (app off, script blocked) the link opens its URL.
     Optional: hide Inbox's own floating "Live chat" button (section setting), the footer link replaces it. */
  (function () {
    if (window.__onFtChat) return;
    window.__onFtChat = true;

    function chatEl() { return document.querySelector('shopify-chat'); }
    function runtimeRoot(el) {
      var rt = el && el.shadowRoot && el.shadowRoot.querySelector('shopify-agent-runtime');
      return rt && rt.shadowRoot;
    }
    function isOpen(el) {
      var root = runtimeRoot(el);
      var panel = root && root.querySelector('[part~="dialog"]');
      return !!(panel && !panel.hasAttribute('inert'));
    }
    function openChat() {
      var el = chatEl();
      if (el && typeof el.show === 'function') {
        // open now; if Inbox is still loading its panel, ask again a few times (it ignores a call it cannot serve yet)
        var tries = 0;
        (function attempt() {
          try { el.show(); } catch (e) {}
          if (!isOpen(el) && ++tries < 12) setTimeout(attempt, 400);
        })();
        return true;
      }
      var old = document.querySelector('inbox-online-store-chat');
      var btn = old && old.shadowRoot && old.shadowRoot.querySelector('button');
      if (btn) { btn.click(); return true; }
      return false;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-on-ft-chat]') : null;
      if (!link) return;
      if (openChat()) {
        event.preventDefault();
      } else if (link.getAttribute('href') === '#') {
        event.preventDefault();
      }
    });

    // hide the floating button: a style inside Inbox's own component (page CSS cannot reach it)
    var hideCss = '.activator-nudge,[part~="activator"]{display:none !important}';
    function hideBubble() {
      var root = runtimeRoot(chatEl());
      if (!root) return false;
      if (!root.querySelector('style[data-on-ft-hide]')) {
        var st = document.createElement('style');
        st.setAttribute('data-on-ft-hide', '');
        st.textContent = hideCss;
        root.appendChild(st);
      }
      return true;
    }
    function startHiding() {
      if (!document.querySelector('[data-on-ft-hide-bubble]')) return;
      var tries = 0;
      (function poll() {
        hideBubble();
        if (++tries < 60) setTimeout(poll, 500);   // Inbox loads late and may rebuild its button: keep checking for 30s
      })();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startHiding);
    else startHiding();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-hero-slider')) {
    customElements.define(
      'on-hero-slider',
      class OnHeroSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ohs-track]');
          this.slides = Array.from(this.querySelectorAll('[data-ohs-slide]'));
          if (!this.track || !this.slides.length) return;

          this.bars = Array.from(this.querySelectorAll('[data-ohs-bar]'));
          this.barsWrap = this.querySelector('[data-ohs-bars]');
          this.prevBtn = this.querySelector('[data-ohs-prev]');
          this.nextBtn = this.querySelector('[data-ohs-next]');
          this.pauseBtn = this.querySelector('[data-ohs-pause]');

          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduce;
          if (!this.autoplay) this.setAttribute('data-autoplay', 'false');
          this.pauseOnHover = this.dataset.pauseHover !== 'false';

          this.index = 0;
          this.lockUntil = 0;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;
          this.frame = null;
          this.flags = { user: false, hover: false, focus: false, hidden: document.hidden, offscreen: false };

          this.onScroll = () => this.schedule();
          this.onBarClick = (event) => {
            const bar = event.target.closest('[data-ohs-bar]');
            if (bar) this.goTo(this.bars.indexOf(bar));
          };
          this.onPrev = () => this.goTo(this.index - 1);
          this.onNext = () => this.goTo(this.index + 1);
          this.onPauseClick = () => this.setUserPaused(!this.flags.user);
          this.onAnimationEnd = (event) => {
            const bar = event.target.closest ? event.target.closest('[data-ohs-bar]') : null;
            if (event.animationName === 'ohs-fill' && bar && bar.classList.contains('is-active') && this.autoplay) {
              this.goTo(this.index + 1);
            }
          };
          this.onKey = (event) => this.keyDown(event);
          this.onEnter = (event) => {
            if (this.pauseOnHover && event.pointerType === 'mouse') this.setFlag('hover', true);
          };
          this.onLeave = (event) => {
            if (event.pointerType === 'mouse') this.setFlag('hover', false);
          };
          this.onFocusIn = (event) => {
            let keyboard = true;
            try {
              keyboard = event.target.matches(':focus-visible');
            } catch (error) {
              keyboard = true;
            }
            if (keyboard) this.setFlag('focus', true);
          };
          this.onFocusOut = () => this.setFlag('focus', false);
          this.onVisibility = () => this.setFlag('hidden', document.hidden);
          this.onPointerDown = (event) => this.dragStart(event);
          this.onPointerMove = (event) => this.dragMove(event);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (event) => event.preventDefault();
          this.onClickCapture = (event) => {
            if (!this.suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('keydown', this.onKey);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.barsWrap) {
            this.barsWrap.addEventListener('click', this.onBarClick);
            this.barsWrap.addEventListener('animationend', this.onAnimationEnd);
          }
          if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
          if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
          if (this.pauseBtn) this.pauseBtn.addEventListener('click', this.onPauseClick);
          this.addEventListener('pointerenter', this.onEnter);
          this.addEventListener('pointerleave', this.onLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          document.addEventListener('visibilitychange', this.onVisibility);

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (entries) => this.setFlag('offscreen', !entries[0].isIntersecting),
              { threshold: 0.35 }
            );
            this.io.observe(this);
          }
          this.resizeObserver = new ResizeObserver(() => this.snapToIndex());
          this.resizeObserver.observe(this.track);

          this.setActive(0, true);
          // the first slide already carries is-entering from the markup; just clear it once it has played
          this.slides[0]._enterTimer = setTimeout(() => this.slides[0].classList.remove('is-entering'), 2600);
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('keydown', this.onKey);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.io) this.io.disconnect();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          clearTimeout(this.settleTimer);
          clearTimeout(this.fadeTimer);
          this.slides.forEach((slide) => clearTimeout(slide._enterTimer));
        }

        /* ---------- Geometry ---------- */
        width() {
          return this.track.clientWidth || 1;
        }
        sign() {
          return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        }

        /* ---------- Active slide ---------- */
        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (Date.now() < this.lockUntil || this.drag) return;
            const index = Math.round(Math.abs(this.track.scrollLeft) / this.width());
            const clamped = Math.max(0, Math.min(this.slides.length - 1, index));
            if (clamped !== this.index) this.setActive(clamped);
          });
        }

        setActive(index, initial = false) {
          const changed = index !== this.index;
          this.index = index;
          this.slides.forEach((slide, i) => {
            const on = i === index;
            slide.classList.toggle('is-active', on);
            slide.inert = !on;
          });
          this.bars.forEach((bar, i) => {
            bar.classList.toggle('is-active', i === index);
            if (i === index) bar.setAttribute('aria-current', 'true');
            else bar.removeAttribute('aria-current');
          });
          this.syncVideos();
          this.updatePaused();
          // swipe, drag, arrows, progress bars and autoplay all end up here: replay the text + button entrance
          if (changed && !initial) this.enterSlide(this.slides[index]);
        }

        snapToIndex() {
          if (this.drag || Date.now() < this.lockUntil) return;
          this.track.scrollTo({ left: this.sign() * this.index * this.width(), behavior: 'auto' });
        }

        // Replays the text + button entrance on a slide
        enterSlide(slide) {
          if (!slide || this.reduce) return;
          clearTimeout(slide._enterTimer);
          slide.classList.remove('is-entering');
          void slide.offsetWidth;
          slide.classList.add('is-entering');
          slide._enterTimer = setTimeout(() => slide.classList.remove('is-entering'), 2600);
        }

        goTo(target) {
          const count = this.slides.length;
          if (count < 2) return;
          const wraps = target < 0 || target >= count;
          const next = (target + count) % count;
          if (next === this.index && !wraps) return;
          this.lockUntil = Date.now() + 900;
          this.setActive(next);

          if (wraps && !this.reduce) {
            // Going from the last slide to the first (or back): fade, jump, fade in. No fast rewind.
            this.track.classList.add('is-fading');
            clearTimeout(this.fadeTimer);
            this.fadeTimer = setTimeout(() => {
              this.track.scrollTo({ left: this.sign() * next * this.width(), behavior: 'auto' });
              this.track.classList.remove('is-fading');
              this.enterSlide(this.slides[next]);
            }, 320);
          } else {
            this.track.scrollTo({
              left: this.sign() * next * this.width(),
              behavior: this.reduce ? 'auto' : 'smooth'
            });
          }
        }

        /* ---------- Autoplay pausing ---------- */
        setFlag(name, value) {
          this.flags[name] = value;
          this.updatePaused();
        }

        setUserPaused(value) {
          this.flags.user = value;
          if (!value) {
            this.flags.focus = false;
            this.flags.hover = false;
          }
          if (this.pauseBtn) {
            this.pauseBtn.setAttribute('aria-pressed', value ? 'true' : 'false');
            this.pauseBtn.setAttribute('aria-label', value ? 'Play slideshow' : 'Pause slideshow');
          }
          this.updatePaused();
        }

        updatePaused() {
          const f = this.flags;
          const paused = f.user || f.hover || f.focus || f.hidden || f.offscreen;
          this.toggleAttribute('data-paused', paused);
          this.syncVideos();
        }

        /* ---------- Videos: only the active slide, only the visible device ---------- */
        syncVideos() {
          if (!this.slides) return;
          const allow = !this.reduce && !this.flags.user && !this.flags.hidden && !this.flags.offscreen;
          this.slides.forEach((slide, i) => {
            slide.querySelectorAll('video').forEach((video) => {
              const visible = video.offsetParent !== null || video.getClientRects().length > 0;
              if (i === this.index && visible && allow) {
                const promise = video.play();
                if (promise && promise.catch) promise.catch(() => {});
              } else {
                video.pause();
              }
            });
          });
        }

        /* ---------- Keyboard ---------- */
        keyDown(event) {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const rtl = this.sign() === -1;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + (rtl ? -1 : 1));
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index + (rtl ? 1 : -1));
          } else if (event.key === 'Home') {
            event.preventDefault();
            this.goTo(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            this.goTo(this.slides.length - 1);
          }
        }

        /* ---------- Mouse drag (touch swipes natively with scroll-snap) ---------- */
        dragStart(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
          if (event.target.closest('a, button')) return;
          this.suppressClick = false;
          this.drag = { x: event.clientX, scroll: this.track.scrollLeft, moved: false, lastX: event.clientX, lastT: performance.now(), velocity: 0 };
          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(event) {
          const d = this.drag;
          if (!d) return;
          const dx = event.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }
          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((event.clientX - d.lastX) / dt);
            d.lastX = event.clientX;
            d.lastT = now;
          }
          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          this.track.classList.remove('is-dragging');
          this.suppressClick = true;

          const sign = this.sign();
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * sign;
          let position = Math.abs(this.track.scrollLeft) / this.width();
          if (Math.abs(moving) > 0.35) position = moving > 0 ? Math.ceil(position) : Math.floor(position);
          else position = Math.round(position);
          const target = Math.max(0, Math.min(this.slides.length - 1, position));

          this.lockUntil = Date.now() + 700;
          this.setActive(target);
          this.track.scrollTo({ left: sign * target * this.width(), behavior: this.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-pdp-accordions"] && !Shopify.designMode) return;
  try {
    
  /* "Size Chart" shortcut: open the Size & Fit accordion on this page and scroll to it */
  (function () {
    if (window.__onSizeChartShortcut) return;
    window.__onSizeChartShortcut = true;

    function openSizeChart() {
      var accordion = document.querySelector('details[data-on-size-chart]');
      if (!accordion) return false;

      accordion.open = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      accordion.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

      var summary = accordion.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
      return true;
    }

    // 1. the drawer's "Size Chart" link (cancelable event: preventDefault = "handled")
    document.addEventListener('on:size-chart-open', function (event) {
      if (openSizeChart()) event.preventDefault();
    });

    // 2. any link / button that points at the size chart
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('a[href="#on-size-chart"], [data-open-size-chart]') : null;
      if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (openSizeChart()) event.preventDefault();
    });

    // 3. a page opened with #on-size-chart
    function fromHash() {
      if (window.location.hash === '#on-size-chart') openSizeChart();
    }
    window.addEventListener('hashchange', fromHash);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
    else fromHash();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-related-products"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Colour viewer (like on.ae): a click on a swatch opens the colour full screen ----------
     One full-size photo per colour of THAT product (the swatches of the card), in swatch order.
     Arrows (bottom left), swipe, keyboard (left / right, Esc), x (top right). The card follows the colour shown,
     so after closing it shows the colour the shopper stopped on. Used when the slider has data-ofc-viewer. */
  if (!window.OfcViewer) {
    window.OfcViewer = (function () {
      let root, img, label, slides = [], index = 0, onPick = null, lastFocus = null, startX = null, token = 0;

      const icon = (d) => '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';

      function build() {
        root = document.createElement('div');
        root.className = 'ofc-lb';
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-label', 'Colours');
        root.hidden = true;
        root.innerHTML =
          '<div class="ofc-lb__stage"><img class="ofc-lb__img" alt="" draggable="false"></div>' +
          '<p class="ofc-lb__label" aria-live="polite"></p>' +
          '<button type="button" class="ofc-lb__btn ofc-lb__close" aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false"><path d="m5.64 5.64 12.72 12.72M5.64 18.36 18.36 5.64"/></svg></button>' +
          '<div class="ofc-lb__nav">' +
          '<button type="button" class="ofc-lb__btn ofc-lb__prev" aria-label="Previous colour">' + icon('m4.707 12.5 4.147 4.146-.707.708L2.793 12l5.354-5.354.707.708L4.707 11.5H21v1H4.707Z') + '</button>' +
          '<button type="button" class="ofc-lb__btn ofc-lb__next" aria-label="Next colour">' + icon('m19.293 11.5-4.147-4.146.708-.708L21.207 12l-5.353 5.354-.708-.707 4.147-4.147H3v-1h16.293Z') + '</button>' +
          '</div>';
        document.body.appendChild(root);
        img = root.querySelector('.ofc-lb__img');
        label = root.querySelector('.ofc-lb__label');
        root.querySelector('.ofc-lb__close').addEventListener('click', close);
        root.querySelector('.ofc-lb__prev').addEventListener('click', () => go(index - 1));
        root.querySelector('.ofc-lb__next').addEventListener('click', () => go(index + 1));
        root.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); close(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - (document.dir === 'rtl' ? -1 : 1)); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + (document.dir === 'rtl' ? -1 : 1)); }
          else if (e.key === 'Tab') {
            // keep the focus inside the viewer
            const f = Array.prototype.filter.call(root.querySelectorAll('button'), (b) => !b.disabled && b.offsetParent !== null);
            if (!f.length) return;
            const i = f.indexOf(document.activeElement);
            if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
            else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
          }
        });
        // swipe (touch and pen; a mouse uses the arrows)
        root.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') startX = e.clientX; });
        root.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1) * (document.dir === 'rtl' ? -1 : 1));
        });
        root.addEventListener('pointercancel', () => { startX = null; });
      }

      function show() {
        const s = slides[index];
        const my = ++token;
        img.style.opacity = '0';
        const loader = new Image();
        if (s.srcset) { loader.srcset = s.srcset; loader.sizes = '100vw'; }
        loader.src = s.src;
        const put = () => {
          if (my !== token) return;
          if (s.srcset) { img.srcset = s.srcset; img.sizes = '100vw'; } else { img.removeAttribute('srcset'); }
          img.src = s.src;
          img.alt = s.name;
          img.style.opacity = '';
        };
        if (loader.decode) loader.decode().then(put, put); else { loader.onload = put; loader.onerror = put; }
        label.textContent = s.name + ' (' + (index + 1) + ' / ' + slides.length + ')';
        const one = slides.length < 2;
        root.querySelector('.ofc-lb__nav').hidden = one;
        // warm the next one
        const n = slides[(index + 1) % slides.length];
        if (n && !one) { const w = new Image(); if (n.srcset) { w.srcset = n.srcset; w.sizes = '100vw'; } w.src = n.src; }
      }

      function go(i) {
        if (!slides.length) return;
        index = (i + slides.length) % slides.length;
        show();
        if (onPick && slides[index].btn) onPick(slides[index].btn);
      }

      function open(card, btn, pick) {
        if (!card || !btn) return;
        const btns = Array.prototype.slice.call(card.querySelectorAll('.ofc-swatch'));
        slides = btns.filter((b) => b.dataset.full || b.dataset.image).map((b) => ({
          btn: b,
          src: b.dataset.full || b.dataset.image,
          srcset: b.dataset.fullSrcset || b.dataset.srcset || '',
          name: b.getAttribute('aria-label') || ''
        }));
        index = slides.findIndex((s) => s.btn === btn);
        if (index < 0) return;   // a colour without a photo: nothing to show
        if (!root) build();
        onPick = pick || null;
        lastFocus = btn;
        // same grey as the card images (setting "Image background"), so photos with a grey background blend in
        const bg = getComputedStyle(card).getPropertyValue('--ofc-media-bg').trim();
        root.style.background = bg || '';
        root.hidden = false;
        document.documentElement.classList.add('ofc-lb-open');
        requestAnimationFrame(() => root.classList.add('is-open'));
        show();
        root.querySelector('.ofc-lb__close').focus({ preventScroll: true });
      }

      function close() {
        if (!root || root.hidden) return;
        token++;
        root.classList.remove('is-open');
        root.hidden = true;
        document.documentElement.classList.remove('ofc-lb-open');
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      }

      return { open: open, close: close };
    })();
  }

  if (!customElements.get('on-featured-collection')) {
    customElements.define(
      'on-featured-collection',
      class OnFeaturedCollection extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ofc-track]');
          if (!this.track) return;

          this.nav = this.querySelector('[data-ofc-nav]');
          this.prev = this.querySelector('[data-ofc-prev]');
          this.next = this.querySelector('[data-ofc-next]');
          this.thumb = this.querySelector('[data-ofc-thumb]');
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;

          this.onScroll = () => this.schedule();
          this.onPrev = () => {
            if (this.prev.getAttribute('aria-disabled') !== 'true') this.page(-1);
          };
          this.onNext = () => {
            if (this.next.getAttribute('aria-disabled') !== 'true') this.page(1);
          };
          this.onKeyDown = (e) => this.keyDown(e);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          this.onSwatchClick = (e) => {
            const btn = e.target.closest ? e.target.closest('.ofc-swatch') : null;
            if (!btn || !this.contains(btn)) return;
            this.selectSwatch(btn);
            if (this.hasAttribute('data-ofc-viewer') && window.OfcViewer) {
              const card = btn.closest('[data-ofc-card]');
              window.OfcViewer.open(card, btn, (b) => this.selectSwatch(b));
            }
          };
          this.track.addEventListener('click', this.onSwatchClick);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          this.track.removeEventListener('click', this.onSwatchClick);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.cancelSettle();
        }

        /* ---------- Colour swatches (same behaviour as the collection grid cards) ---------- */
        selectSwatch(btn) {
          if (btn.classList.contains('is-active')) return;
          const card = btn.closest('[data-ofc-card]');
          if (!card) return;

          card.querySelectorAll('.ofc-swatch').forEach((swatch) => {
            const on = swatch === btn;
            swatch.classList.toggle('is-active', on);
            swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          card.classList.add('is-swatched');

          // The card links now open the chosen colour
          if (btn.dataset.url) {
            card.querySelectorAll('[data-ofc-link]').forEach((link) => link.setAttribute('href', btn.dataset.url));
          }

          // The badge of the chosen colour (empty = this colour has none)
          const badge = card.querySelector('[data-ofc-badge]');
          if (badge && btn.hasAttribute('data-badge')) {
            const text = btn.getAttribute('data-badge') || '';
            badge.textContent = text;
            badge.hidden = !text;
          }

          // The main image: preload, then fade
          const img = card.querySelector('.ofc-img--main');
          const src = btn.dataset.image;
          if (!img || !src) return;
          const srcset = btn.dataset.srcset;
          const token = String(Date.now()) + Math.random();
          card.dataset.swapToken = token;
          const loader = new Image();
          if (srcset) loader.srcset = srcset;
          if (img.sizes) loader.sizes = img.sizes;
          loader.src = src;
          const swap = () => {
            if (card.dataset.swapToken !== token) return;
            img.style.transition = 'opacity 0.16s ease';
            img.style.opacity = '0';
            setTimeout(() => {
              if (card.dataset.swapToken !== token) return;
              if (srcset) img.srcset = srcset;
              img.src = src;
              img.style.opacity = '';
              setTimeout(() => { if (card.dataset.swapToken === token) img.style.transition = ''; }, 200);
            }, 160);
          };
          if (loader.decode) loader.decode().then(swap, swap);
          else if (loader.complete) swap();
          else { loader.onload = swap; loader.onerror = swap; }
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          // the first VISIBLE card (the related products section keeps a Men and a Women card per product, one is hidden)
          let slide = null;
          for (const el of track.querySelectorAll('.ofc-slide')) {
            if (el.getClientRects().length) { slide = el; break; }
          }
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          const step = slide.getBoundingClientRect().width + gap;
          return {
            step,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            visible: Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.05)),
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        /* Prev / next buttons: move one "page" of fully visible cards */
        page(direction) {
          const m = this.metrics();
          if (!m) return;
          this.track.scrollBy({
            left: direction * m.sign * m.step * m.visible,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        /* Keyboard: left/right arrows move one card, Home/End jump to the ends */
        keyDown(e) {
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          const m = this.metrics();
          if (!m) return;

          const behavior = m.reduce ? 'auto' : 'smooth';
          if (e.key === 'ArrowRight') {
            this.track.scrollBy({ left: m.step, behavior });
          } else if (e.key === 'ArrowLeft') {
            this.track.scrollBy({ left: -m.step, behavior });
          } else if (e.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior });
          } else if (e.key === 'End') {
            this.track.scrollTo({ left: m.sign * m.max, behavior });
          } else {
            return;
          }
          e.preventDefault();
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign; // > 0 means the scroll position is increasing
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        /* ---------- UI state ---------- */
        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.nav) this.nav.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);

          if (this.thumb) {
            const width = Math.min(100, Math.max(12, (track.clientWidth / track.scrollWidth) * 100));
            const offset = (position / max) * (100 - width);
            this.thumb.style.setProperty('--ofc-thumb-w', width + '%');
            this.thumb.style.setProperty('--ofc-thumb-x', offset + '%');
          }

          // Dim (or hide, see data-end) the arrows at the start / end of the track
          if (this.prev) this.prev.setAttribute('aria-disabled', position <= 2 ? 'true' : 'false');
          if (this.next) this.next.setAttribute('aria-disabled', position >= max - 2 ? 'true' : 'false');
        }
      }
    );
  }

  /* Related products: the cards follow the product page's Women | Men toggle (data-gender on the slider) */
  (function () {
    if (window.__onRpGender) return;
    window.__onRpGender = true;

    function toKey(text) {
      var t = String(text || '').toLowerCase();
      if (/women|woman|female|ladies|نساء/.test(t)) return 'women';
      if (/men|man|male|رجال/.test(t)) return 'men';
      return '';
    }
    function pageGender() {
      var radio = document.querySelector('.product-form__input--on-gender input:checked');
      if (radio) return toKey(radio.value);
      var link = document.querySelector('on-gender-toggle .on-gender__item.is-current');
      if (link) return toKey(link.getAttribute('data-gender') || link.textContent);
      return '';
    }
    function apply(key) {
      var k = key === undefined ? pageGender() : key;
      document.querySelectorAll('on-featured-collection[data-rp-follow]').forEach(function (el) {
        if (el.getAttribute('data-gender') === k) return;
        el.setAttribute('data-gender', k);
        var track = el.querySelector('[data-ofc-track]');
        if (track) {
          track.scrollLeft = 0;
          track.dispatchEvent(new Event('scroll'));
        }
      });
    }
    // the related products arrive after the page has loaded: set the gender as soon as they are in the page
    new MutationObserver(function () {
      if (document.querySelector('on-featured-collection[data-rp-follow]:not([data-gender])')) apply();
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('.product-form__input--on-gender')) apply();
    });
    document.addEventListener('on:gender-change', function (event) {
      apply(event.detail && event.detail.value ? toKey(event.detail.value) : undefined);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
    else apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-seo-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-seo-footer')) {
    customElements.define(
      'on-seo-footer',
      class OnSeoFooter extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-clamp')) return;

          this.desc = this.querySelector('[data-osf-desc]');
          this.toggle = this.querySelector('[data-osf-toggle]');
          if (!this.desc || !this.toggle) return;

          this.expanded = false;
          this.onClick = () => this.setExpanded(!this.expanded);
          this.toggle.addEventListener('click', this.onClick);

          this.setAttribute('data-ready', '');
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.desc);
          this.measure();
        }

        disconnectedCallback() {
          if (this.toggle && this.onClick) this.toggle.removeEventListener('click', this.onClick);
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        setExpanded(expanded) {
          this.expanded = expanded;
          this.desc.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
          this.measure();
          if (!expanded) this.toggle.scrollIntoView({ block: 'nearest' });
        }

        measure() {
          const desc = this.desc;
          if (this.expanded) {
            desc.classList.remove('is-clamped');
            this.toggle.hidden = false;
            return;
          }
          const overflows = desc.scrollHeight - desc.clientHeight > 1;
          desc.classList.toggle('is-clamped', overflows);
          this.toggle.hidden = !overflows;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
